import React, { useState, useEffect } from "react";

const AnimatedNumber = ({ value, duration = 1000 }) => {
  const [currentValue, setCurrentValue] = useState(0);

  useEffect(() => {
    let startValue = 0;
    const endValue = parseInt(value, 10) || 0; // Ensure value is a number
    const startTime = performance.now();

    const animateCount = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1); // Ensure progress doesn't exceed 1

      const nextValue = Math.floor(
        progress * (endValue - startValue) + startValue
      );
      setCurrentValue(nextValue);

      if (progress < 1) {
        requestAnimationFrame(animateCount);
      } else {
        setCurrentValue(endValue); // Ensure final value is exact
      }
    };

    const animationFrameId = requestAnimationFrame(animateCount);

    // Cleanup function
    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [value, duration]); // Rerun animation if value or duration changes

  // Format number with commas for better readability
  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div style={{ fontSize: "20px", margin: 0 }} className="">
      {formatNumber(currentValue)}
    </div>
  );
};

export default AnimatedNumber;
